import Button from "./Button";
import { cn } from "../lib/utils";

function MentorActivityPanel({
  mentors,
  contentItems,
  theme,
  selectedMentorId,
  onMentorSelect,
  onStartClick,
  currentUserId,
  editable
}) {
  const getMentorCompletion = (mentor) => {
    if (!mentor.id) return false
    const hasContent = contentItems.some(item => {
      return item.user_id === mentor.id
    })
    return hasContent
  }

  const currentUserComplete = contentItems.some(item => item.user_id === currentUserId)

  if (!mentors || mentors.length === 0) {
    return null
  }

  // Blessings uses horizontal grid, others use vertical column
  const isHorizontalLayout = theme === "blessings"

  return (
    <div className="mb-6">

      {editable && !currentUserComplete && (
        <div className="flex justify-center mb-4">
          <Button variant="secondary" onClick={onStartClick} className="py-1" type="button">Start</Button>
        </div>
      )}

      <div className={cn(
        "gap-2 mt-4",
        isHorizontalLayout ? "grid grid-cols-1 md:grid-cols-3" : "flex flex-col items-center"
      )}>
        {mentors.map(mentor => {
          const isComplete = getMentorCompletion(mentor)
          const isSelected = selectedMentorId === mentor.user_id

          return (
            <button
              key={mentor.id}
              type="button"
              onClick={() => isComplete && onMentorSelect(isSelected ? null : mentor.user_id)}
              className={cn(
                "flex items-center gap-2 px-3 py-1 rounded-full border relative justify-center font-bold",
                isComplete ? "border-green-500 text-green-600 cursor-pointer" : "border-gray-300 text-gray-400 cursor-default",
                isSelected && "bg-green-50",
                !isHorizontalLayout && "w-full max-w-xs justify-center"
              )}
              disabled={!isComplete}
            >
              {isComplete ? (
                <i className="fa-solid fa-circle-check text-green-500 absolute left-2 top-1/2 -translate-y-1/2 text-xl" />
              ) : (
                <i className="fa-solid fa-circle-minus text-gray-300 absolute left-2 top-1/2 -translate-y-1/2 text-xl" />
              )}
              <span>{mentor.first_name}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default MentorActivityPanel;